import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { default as Actions } from '../actions';
import * as CommonActions from '../../common/actions';
import * as Util from '../../common/utilities/';

import { BrandBand } from '../../common/components';
import { Header, FallbackOverview, McMenu } from '../components/';

export class Fallback extends Component {
  componentDidMount() {
    this.props.actions.getAssetTypes();
  }

  componentDidUpdate(prevProps) {
    if (Util.propChanged(prevProps, this.props, 'fallback.data.savedAsset')) {
      this.props.actions.getAssetTypes();
    }
  }

  render() {
    return (
      <McMenu
        flags={this.props.flags}
        history={this.props.history}
        route="/fallback"
      >
        <BrandBand>
          <Header route={this.props.match} />
          <FallbackOverview
            actions={this.props.actions}
            assets={this.props.assets}
            modals={this.props.modals}
            fallback={this.props.fallback}
            assetTypes={this.props.assets.data.types}
          />
        </BrandBand>
      </McMenu>
    );
  }
}

Fallback.contextTypes = {
  router: PropTypes.object
};

Fallback.propTypes = {
  assets: PropTypes.object,
  flags: PropTypes.object,
  actions: PropTypes.object,
  modals: PropTypes.object,
  location: PropTypes.object
};

function mapStateToProps(state) {
  return {
    assets: state.ecs.assets,
    fallback: state.ecs.fallback,
    flags: state.ecs.flags,
    modals: state.modals
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...Actions, ...CommonActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Fallback);
